"use client";
import { useEffect } from "react";
import LogRocket from "logrocket";

import { initLogRocket } from "@/lib/logrocket";
import { useCurrentUser } from "@/hooks/use-current-user";

export default function LogRocketInit() {
  const [currentUser, authStatus] = useCurrentUser();
  const isLocalhost = process.env.NODE_ENV === "development" && !process.env.NEXT_PUBLIC_ENABLE_LOGROCKET_DEV;

  useEffect(() => {
    if (isLocalhost) {
      console.log("🔧 LogRocket is disabled on localhost");
      return;
    }

    // Initialize LogRocket
    LogRocket.log("🚀 Initializing LogRocket...");
    initLogRocket();
    LogRocket.log("✅ LogRocket initialized successfully");
  }, []);

  useEffect(() => {
    if (isLocalhost) {
      console.log("🔧 Skipping user identification on localhost");
      return;
    }

    if (currentUser && currentUser.uid) {
      try {
        LogRocket.log("👤 Identifying user in LogRocket:", currentUser.uid);
        LogRocket.identify(currentUser.uid, {
          name: currentUser.displayName ?? "",
          email: currentUser.email ?? "",
          uid: currentUser.uid,
          // Add any other user properties you want to track
        });
        LogRocket.log("✅ LogRocket user identified:", currentUser.uid);
      } catch (error) {
        console.error("❌ Failed to identify user in LogRocket:", error);
      }
    } else {
      LogRocket.log("👤 No user is currently logged in");
    }
  }, [currentUser]);

  return null;
}
